import type { ReactNode } from 'react'

import LeangapLogo from './LeangapLogo'

interface PublicHeaderProps {
	children?: ReactNode
	description?: string
	subDescription?: string
}

export default function PublicHeader({ children, description, subDescription }: PublicHeaderProps) {
	return (
		<header className="mb-10 flex flex-col items-center">
			<LeangapLogo width={180} />
			{description && <p className="mt-2 text-center text-lg">{description}</p>}
			{subDescription && <p className="text-center text-sm text-neutral-400">{subDescription}</p>}
			{children}
		</header>
	)
}
